// extracted by mini-css-extract-plugin
export default {"container":"Title_container__RZxb2","center":"Title_center__yDrL5","leftAlign":"Title_leftAlign__bTcRE","title":"Title_title__P-FsM","subTitle":"Title_subTitle__+U8op"};